import { BaseEntity } from '../../../app/core';

export class Insured extends BaseEntity {
    name: string;
    cuit: string;
    street: string;
    streetNumber: string;
    floor: string;
    apartment: string;
    postalCode: string;
    countryId: number;
    stateId: number;
    city: string;
    phone: string;
    electronicAddress: string;
    sinisterEmail: string;
    legalEmail: string;
    comercialEmail: string;
    legalContactEmail: string;
    agreeConditions: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/insured.ts